
const {filterURL, requestPenddingExpire:REQUEST_PENDDING_EXPIRE } = window.ProjectConfig

const urls = filterURL ? [/\/p\/c\/code\/login*/g, /\/p\/c\/message\/login*/g].concat(filterURL) : [/\/p\/c\/code\/login*/g, /\/p\/c\/message\/login*/g];

export const filterUrl = (url) => urls.some(v => url.match(v));

export const enableGateWay = () => (window.ProjectConfig && typeof window.ProjectConfig.enableGateWay === 'boolean' ? window.ProjectConfig.enableGateWay : false);
export const enableLoginPro = window.ProjectConfig && window.ProjectConfig.enableLoginPro ? window.ProjectConfig.enableLoginPro : false;
export const Version = () => (window.ProjectConfig && window.ProjectConfig.Version && window.ProjectConfig.Version === '1.4' ? '1.4' : '1.3');
export const encryptedPassword = () => (window.ProjectConfig && window.ProjectConfig.encryptedPassword ? window.ProjectConfig.encryptedPassword : false);
export const classFix = window.ProjectConfig && window.ProjectConfig.classFix ? window.ProjectConfig.classFix : '';
export const enableChangeLang = window.ProjectConfig && window.ProjectConfig.enableChangeLang ? window.ProjectConfig.enableChangeLang : false;
export const enableInitializationRequest = () => (window.ProjectConfig && typeof window.ProjectConfig.enableInitializationRequest === 'boolean' ? window.ProjectConfig.enableInitializationRequest : true);
export const cbs = () => (window.ProjectConfig && window.ProjectConfig.cbs ? window.ProjectConfig.cbs : {});
export const dateStorageTime = () => (window.ProjectConfig && window.ProjectConfig.dateStorageTime ? window.ProjectConfig.dateStorageTime : 1);


export const isJSON = (str) => {
  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str);
      if (obj && typeof obj === 'object' && obj !== null) {
        return true;
      }
    } catch (e) {
      return false;
    }
  }
  return false;
};

export const checkTime = (lastTime) => new Date().getTime() - lastTime < REQUEST_PENDDING_EXPIRE()
